import Image from 'next/image';

import { getDotcmsImageURL } from '@/app/utils/getDotcmsImageURL';
import TagList from '@/components/shared/TagList';

export function CaseStudyIntro({ client, industry }) {
    const { identifier, logo } = client || {};

    const industries = industry?.categories?.map((item) => item.name);
    const tags = (industries ?? []).map((ind) => ({
        text: ind,
        fontColor: 'text-white',
        bgColor: 'bg-blue-600'
    }));

    return (
        <aside className="flex flex-col gap-6 self-start rounded-xl border border-white/10 bg-white/5 p-3">
            {!!logo && (
                <div className="rounded-lg bg-white p-2">
                    <div className="flex items-center justify-center">
                        <Image
                            src={getDotcmsImageURL({ src: identifier })}
                            width={160}
                            height={80}
                            quality={55}
                            className="h-24 w-auto object-contain"
                            alt="Client logo"
                            priority
                        />
                    </div>
                </div>
            )}

            {tags.length > 0 && (
                <div className="flex flex-col gap-2">
                    <p className="text-sm font-semibold uppercase tracking-widest text-fuschia-400">
                        Industry
                    </p>
                    <TagList tags={tags} />
                </div>
            )}
        </aside>
    );
}
